import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import { filterPage } from "components/common/Filters/FiltersHelper";
import PreferredEmailBanner from "components/common/PreferredEmailBanner";
import Typography from "components/common/Typography";
import UrlTabs from "components/common/UrlTabs";
import { useTranslate } from "hooks/useTranslate";
import { orderBy, uniqBy } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { accessTypes } from "utils/CommonConstants";
import { getLoggedInUserDetails } from "utils/CommonFunctions";
import ReleaseHighlight from "../MyDashboard/ReleaseHighlight";
import PlanAssignment from "../PlanAssignment";
import { clearChildFilters, setBrands } from "./AboveProperty.slice";
import "./AbovePropertyDashboard.scss";
import BookmarkedPlans from "./BookmarkedPlans";
import BookmarkedProperties from "./BookmarkedProperties";
import PlanView from "./PlanView";
import PropertyView from "./PropertyView";

const AboveProperty = () => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const [searchParams] = useSearchParams();
  const { isMobileScreen } = useContext(ThemeContext);

  const isAbovePropertyUser = useAppSelector((state) => state.app.loggedInUserDetails.isAbovePropertyUser);
  const { propertyList } = useAppSelector((state) => state.aboveProperty);

  const [isOpenPlanAssignmentDialog, setIsOpenPlanAssignmentDialog] = useState(false);

  const loggedInUserDetails = getLoggedInUserDetails();

  const tabDetails = [
    { label: translate("dashboard.hotelView"), content: PropertyView, filtersToClear: [filterPage.hotelDisplay] },
    {
      label: translate("dashboard.planView"),
      content: PlanView,
      filtersToClear: [
        filterPage.plansPageAssignedPlansDisplay,
        filterPage.plansPageTemplatePlansDisplay,
        filterPage.plansPageBrandDeadlineDisplay,
        filterPage.plansPageInitiativesDisplay
      ]
    }
  ];

  const handleCloseDialog = () => {
    setIsOpenPlanAssignmentDialog(false);
  };

  useEffect(() => {
    dispatch(clearChildFilters());
  }, []);

  useEffect(() => {
    (async () => {
      const brandOptions = orderBy(uniqBy(propertyList, "brandName"), "brandName");
      const brandsArray = brandOptions?.filter((b: any) => b?.brandName);
      dispatch(setBrands(brandsArray));
    })();
  }, [propertyList]);

  return (
    <Stack className="above_property_dashboard" direction={isMobileScreen ? "column" : "row"}>
      <Stack sx={{ flex: 1, pr: isMobileScreen ? 0 : "24px", overflowX: "auto" }}>
        <Grid display="flex" justifyContent={"space-between"} flexDirection={isMobileScreen ? "column" : "row"}>
          {" "}
          <Typography
            variant="h4"
            showBold
            textAlign={"center"}
            color={tokens.Text.General.PrimaryHeadline}
            sx={{
              paddingY: isMobileScreen ? "12px" : "24px"
            }}
          >
            {translate("dashboard.heading")}
          </Typography>
          {isAbovePropertyUser && (
            <Button
              label="Assign Plan"
              sx={{ marginTop: "12px" }}
              accessType={accessTypes.assign}
              onClick={() => setIsOpenPlanAssignmentDialog(true)}
            />
          )}
        </Grid>
        {loggedInUserDetails &&
          Object.keys(loggedInUserDetails).length !== 0 &&
          !loggedInUserDetails?.preferredEmail && <PreferredEmailBanner />}

        <UrlTabs scrollTarget="tableDiv" tabs={tabDetails} />
      </Stack>
      {!isMobileScreen && (
        <Stack id="bookmarkListContainer" className="bookmark_container">
          <ReleaseHighlight class="dark" />
          {searchParams.get("parentTab") === "Plan View" ? <BookmarkedPlans /> : <BookmarkedProperties />}
        </Stack>
      )}
      {isOpenPlanAssignmentDialog && (
        <PlanAssignment
          open={isOpenPlanAssignmentDialog}
          handleCloseDialog={handleCloseDialog}
          userSelectionFlow="third"
        />
      )}
    </Stack>
  );
};

export default AboveProperty;
